import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';
import {AreaIcon} from '../../../common/icons';

import './MapMenu.css';

@inject('translationsStore')
@observer
export default class MapMenu extends Component {
  render() {
    const { translationsStore } = this.props;

    if (!(this.props.hasOwnProperty('visible') && !this.props.visible)) {
      return (
        <div className={`MapMenu ${this.props.className || ''}`} style={this.props.style}>
          { !this.props.triggerRender ?
              <div className="MapMenuTrigger" style={{padding: '0 10px'}} onClick={isFunction(this.props.onToggleCollapse) ? this.props.onToggleCollapse : undefined}>
                <AreaIcon width={16} height={16} />
                <div style={{marginTop: 0}}>{translationsStore.translate('mapMenu.trigger.labelArea')}</div>
              </div>
            :
              (this.props.triggerRender)
          }
          { !this.props.collapsed &&
            (this.props.children)
          }
        </div>
      );
    } else {
      return <Fragment />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapMenu/MapMenu.js